import { render, staticRenderFns } from "./ListAccountant.vue?vue&type=template&id=8252fec4&scoped=true"
import script from "./ListAccountant.vue?vue&type=script&lang=js"
export * from "./ListAccountant.vue?vue&type=script&lang=js"
import style0 from "./ListAccountant.vue?vue&type=style&index=0&id=8252fec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8252fec4",
  null
  
)

export default component.exports